export const formationData = [
  {
    imageSrc: "/assets/images/home/automobile.png",
    imageTitle: "Automobile",
    imageLink: "/formations-automobile",
    roles: [
      { title: "Software Developer", link: "/formation-software-developer" },
      { title: "System Engineer", link: "/formation-system-engineer" },
      { title: "Lighting", link: "/formation-lighting" },
      { title: "Liaison au sol", link: "/formation-liaison-sol" },
    ],
  },
  {
    imageSrc: "/assets/images/home/nucleaire.png",
    imageTitle: "Nucleaire",
    imageLink: "/formations-nucleaire",
    roles: [
      {
        title: "Ingénieur Sureté Nucléaire",
        link: "/formation-ingenieur-surete-nucleaire",
      },
      {
        title: "Ingénieur fonctionnement nucléaire",
        link: "/formation-ingenieur-fonctionnement-nucleaire",
      },
      {
        title: "Ingénieur qualité nucléaire",
        link: "/formation-ingenieur-qualite-nucleaire",
      },
    ],
  },
  {
    imageSrc: "/assets/images/home/ferroviaire.png",
    imageTitle: "Ferroviaire",
    imageLink: "/formations-ferroviaire",
    roles: [
      {
        title: "Ingénieur Système Ferroviaire",
        link: "/formation-ingenieur-systeme-ferroviaire",
      },
    ],
  },
  {
    imageSrc: "/assets/images/home/aeronautique.png",
    imageTitle: "Aéronautique",
    imageLink: "/formations-aeronautique",
    roles: [
      {
        title: "Concepteur systèmes embarqués",
        link: "/formation-concepteur-systemes-embarques",
      },
      {
        title: "Technicien banc d’essai",
        link: "/formation-technicien-banc-essai",
      },
    ],
  },
  {
    imageSrc: "/assets/images/home/navale.png",
    imageTitle: "Navale",
    imageLink: "/formations-navale",
    roles: [
      {
        title: "Dessinateur construction navale",
        link: "/formation-dessinateur-construction-navale",
      },
      {
        title: "Dessinateur projeteur tuyauterie",
        link: "/formation-dessinateur-projeteur-tuyauterie",
      },
    ],
  },
  {
    imageSrc: "/assets/images/home/btp-tertiaire.png",
    imageTitle: "BTP-Tertiaire",
    imageLink: "/formations-btp-tertiaire",
    roles: [
      {
        title: "Technicien CVC",
        link: "/formation-technicien-cvc",
      },
      {
        title: "Technicien de Maintenance Multi-technique",
        link: "/formation-technicien-maintenance-multi-technique",
      },
      {
        title: "Technicien de Maintenance Industrielle",
        link: "/formation-technicien-maintenance-industrielle",
      },
      {
        title: "Technicien de Maintenance Industrielle Automatisme",
        link: "/formation-technicien-maintenance-industrielle-automatisme",
      },
    ],
  },
];
